import { gql } from '@apollo/client';

export const PRODUCT_OFFERS_TYPES_QUERY = gql`
  query ProductOffersTypes($filter: ProductOffersFilterInput) {
    productOffers(filter: $filter) {
      nodes {
        type
      }
    }
  }
`;

export const PRODUCT_TABLE_OFFERS_QUERY = gql`
  query ProductTableOffers($filter: ProductOffersFilterInput) {
    productOffers(filter: $filter) {
      nodes {
        id
        type
        name
        apy
        minAmount
        balanceComputation
        interestPosted
        maturity {
          unit
          duration
        }
        productBank {
          id
          name
          logoUrl
        }
      }
    }
  }
`;

export const PRODUCT_DOCUMENT_QUERY = gql`
  query getProductOfferDocument($productId: ID!) {
    productOfferDocument(id: $productId) {
      id
      content
    }
  }
`;
